import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Typography } from 'antd';
import LoginPage from './components/LoginPage';
import CustomModal from 'common/CustomModal';
import {
  login,
  resetSessionConflict,
  resetPasswordExpired
} from './redux/slice';

const { Text } = Typography;

const Login = () => {
  const {
    loading,
    session_conflict,
    conflict_credentials,
    password_expired,
    fpc_token,
    expired_employee_id
  } = useSelector((state) => state.login);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onSubmit = (payload) => {
    dispatch(login(payload));
  };

  const onConfirmDisplace = () => {
    dispatch(login({ ...conflict_credentials, force_displace: true }));
  };

  const onCancelConflict = () => {
    dispatch(resetSessionConflict());
  };

  const onGoToChangePassword = () => {
    navigate(
      `/change-password?user_id=${encodeURIComponent(
        expired_employee_id
      )}&fpc_token=${fpc_token}&expired=1`
    );
    dispatch(resetPasswordExpired());
  };

  const onCancelExpired = () => {
    dispatch(resetPasswordExpired());
  };

  return (
    <>
      <LoginPage loading={loading} onSubmit={onSubmit} />
      <CustomModal
        title="Password Expired"
        visible={password_expired}
        onCancel={onCancelExpired}
        okText="Change Password"
        cancelText="Cancel"
        okButtonProps={{ onClick: onGoToChangePassword }}
        cancelButtonProps={{ onClick: onCancelExpired }}
        closable={false}
        maskClosable={false}
        width={480}
      >
        <Text>
          Your password has expired and must be changed before you can sign in.
          Click &quot;Change Password&quot; to set a new one now.
        </Text>
      </CustomModal>
      <CustomModal
        title="Active Session Detected"
        visible={session_conflict}
        onCancel={onCancelConflict}
        okText="Yes, log me in here"
        cancelText="No, keep other session"
        okButtonProps={{ onClick: onConfirmDisplace, loading }}
        cancelButtonProps={{ onClick: onCancelConflict }}
        closable={false}
        maskClosable={false}
        width={480}
      >
        <Text>
          You are already logged in on another device. Would you like to log out
          from there and continue here?
        </Text>
      </CustomModal>
    </>
  );
};

export default Login;
